/*
 * @Author: scg
 * @Date: 2022-01-06 22:07:36
 * @LastEditTime: 2022-01-20 09:51:40
 * @LastEditors: scg
 * @Description:
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import languageTranslation from "@/components/languageTranslation";
// import Mint from 'mint-ui'
import { Swipe, SwipeItem } from "mint-ui";
import "mint-ui/lib/style.css";
import "@/assets/iconfont.css";
import i18n from "@/langurage/i18n";
import { downloadFilePic } from "@/api/getUrlBase64";
import Video from "video.js";
import "video.js/dist/video-js.css";

// import "@/assets/ar.css";

import "leaflet/dist/leaflet.css";
// 引入Leaflet对象 挂载到Vue上，便于全局使用，也可以单独页面中单独引用
import * as L from "leaflet";

Vue.L = Vue.prototype.$L = L;
Vue.prototype.downloadFilePic = downloadFilePic;


Vue.prototype.payHref = {
  en: "https://www.spylix.com/payment.html",
  ar: "https://www.spylix.com/ar/payment.html",
  br: "https://www.spylix.com/br/pagamento.html",
  de: "https://www.spylix.com/de/zahlung.html",
  es: "https://www.spylix.com/es/pago.html",
  fr: "https://www.spylix.com/fr/paiement.html",
  it: "https://www.spylix.com/it/pagamento.html",
  jp: "https://www.spylix.com/jp/payment.html",
  tr: "https://www.spylix.com/tr/odeme.html"
};
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import echarts from "echarts";
import locale from "element-ui/lib/locale/lang/en";
Vue.prototype.$video = Video;
Vue.prototype.$echarts = echarts;
Vue.prototype.$arrGroup = (arr, fn) => {
  const obj = {};
  arr.forEach((item) => {
    const key = JSON.stringify(fn(item));
    obj[key] = obj[key] || [];
    obj[key].push(item);
  });
  return Object.keys(obj).map((k) => {
    return obj[k];
  });
};
Vue.prototype.$initMapPopups = (datas) => {
  let popups = {};
  for (let i = 0; i < datas.length; i++) {
    let item = datas[i];
    let lat = item[0].latitude;
    let lon = item[0].longitude;
    let date = item
      .map((ii) => ii.createtime)
      .sort((a, b) => new Date(a) - new Date(b));
    let str = "";
    for (let i = 0; i < date.length; i++) {
      str += `<p style="font-size:14px;">${date[i]}</p>`;
    }
    let popup = L.popup().setLatLng([lat, lon]).setContent(str);
    popups[[lat, lon]] = popup;
  }
  return popups;
};
Vue.component("languageTranslation", languageTranslation);

// Vue.use(ElementUI)
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) });
// import 'mint-ui/lib/index.js'
// import {Swipe, SwipeItem} from 'mint-ui'
// Vue.use(Mint)
Vue.config.productionTip = false;
// import MintUI from 'mint-ui'
// import 'mint-ui/lib/style.css'
// Vue.use(MintUI)
/* eslint-disable no-new */
// Vue.component(DatetimePicker.name, DatetimePicker)
console.log(i18n);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
new Vue({
  el: "#app",
  // render: h => h(App),
  i18n,
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js